import React, {Component} from 'react';
import * as routes from '../../const/routes';
import CloseBtn from '../../components/CloseBtn';
import {withUiContext} from "../../UiContext";
import Swipe from '../../components/Swipe/swipe';
import InnerWrap from './Wrap';
import BackSound from '../../components/BackSound';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import MenuBtn from "../../components/MenuBtn";
import NavContent from "../../components/NavContent";
import Bg from '../../assets/img/bg2.jpg'
import Languages from '../../const/languages';

class Prod330 extends Component {

    state = {
        popup: {
            type: null,
            opened: false,
            data: null,
        }
    }

    toggleNav = () => {
        this.setState((prevState) => ({navContent: !prevState.navContent}))
    }

    popupCloseHandler = () => {
        this.setState({
            popup: {
                classSfx: null,
                opened: false,
                data: null,
            }
        })
    }

    popupOpenHandler = (data, classSfx = 'cart') => {
        this.setState({
            popup: {
                classSfx,
                opened: true,
                data,
            }
        })
    }

    render() {
        const { popup, navContent } = this.state;

        return (
            <InnerWrap
                video={false}
                bg={Bg}
                title={Languages.equipment10}
                popup={popup}
                popupCloseHandler={this.popupCloseHandler}
            >
                <MenuBtn className="fadeOutLeft" onClick={this.toggleNav} />

                <TransitionGroup className="menu-outer">
                    { navContent && (
                        <CSSTransition timeout={300} classNames="menu-transition">
                            <NavContent onClose={this.toggleNav}/>
                        </CSSTransition>
                    )}
                </TransitionGroup>

                <Swipe section="10-35" click={this.popupOpenHandler} />

                <CloseBtn link={routes.PROD}/>

                <BackSound navContent={false} />
            </InnerWrap>
        )
    }
}

export default withUiContext(Prod330)
